import { render } from "./app-form-edit.vue?vue&type=template&id=2d8047df"
import script from "./app-form-edit.vue?vue&type=script&lang=js"
export * from "./app-form-edit.vue?vue&type=script&lang=js"

import "./app-form-edit.vue?vue&type=style&index=0&id=2d8047df&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__